






















import { Component, Prop, Vue } from 'vue-property-decorator';
import { CartItemExtraView } from '@/types';

@Component
export default class CartItem extends Vue {
  @Prop() private quantity!: number;

  @Prop() private name!: string;

  @Prop() private size!: string;

  @Prop() private note!: string;

  @Prop() private price!: string;

  @Prop() private extras!: CartItemExtraView[] | undefined;

  @Prop() private isExpanded!: boolean;
}
